export default __webpack_public_path__ + "static/media/ff-landing.5a69bfb2.jpg";